import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field, useFormState } from 'react-final-form';
import { connect } from 'react-redux';
import { TextField, DateField } from '../../atoms';
import { Row, Col, Button, Spin } from 'antd';
import {
  FORM_REGISTER_REPRESENTATIVE_COMPANY,
  formRegisterRepresentativeCompanyFields,
} from '../../constants/formRegister';
import {
  getAddMandateCompany,
  getUpdateMandateCompany,
} from '../../reducers/registerAddMandateReducer';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import {
  addMandateCompany,
  updateMandateCompany,
} from '../../actions/actionCreators/registerActionCreators';
import { AutoCompleteCompaniesField } from '../../components';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';
import validateSchema from './validateSchema';
import FormStateToRedux from '../FormStateToRedux';
import isEqual from 'lodash/isEqual';
import './RegisterRepresentCompany.css';

const RegisterRepresentCompanyFields = ({ t, closeModal }) => {
  const { values } = useFormState({ subscription: { values: true } });
  const companyName =
    values?.[formRegisterRepresentativeCompanyFields.COMPANY_NAME];

  return (
    <>
      <Row gutter={32}>
        {companyName ? (
          <Col span={12}>
            <Field
              name={formRegisterRepresentativeCompanyFields.COMPANY_NAME}
              component={TextField}
              type="text"
              label={t('representation.company_name_label')}
              disabled
            />
          </Col>
        ) : (
          <Col span={12}>
            <Field
              name={formRegisterRepresentativeCompanyFields.LEGAL_ENTITY_ID}
              component={AutoCompleteCompaniesField}
              type="text"
              label={t('representation.company_name_label')}
              required
            />
          </Col>
        )}
      </Row>
      <Row gutter={32}>
        <Col span={12}>
          <Field
            name={formRegisterRepresentativeCompanyFields.MANDATE_DATE_START}
            component={DateField}
            showTime
            label={t('representation.mandate_date_start_label')}
            className="form-register-representation-company__date-field"
            required
          />
        </Col>
        <Col span={12}>
          <Field
            name={formRegisterRepresentativeCompanyFields.MANDATE_DATE_END}
            component={DateField}
            showTime
            label={t('representation.mandate_date_end_label')}
            className="form-register-representation-company__date-field"
          />
        </Col>
      </Row>
      <div className="component-register-actions">
        <Button
          className="component-register-actions__button-previous"
          size="large"
          onClick={closeModal}
        >
          {t('representation.company_cancel')}
        </Button>
        <Button
          className="component-register-actions__button-next"
          size="large"
          type="primary"
          htmlType="submit"
        >
          {t('representation.company_add')}
        </Button>
      </div>
    </>
  );
};

RegisterRepresentCompanyFields.propTypes = {
  t: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export class RegisterRepresentCompany extends Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
    isLoading: PropTypes.bool,
    addMandateCompany: PropTypes.func.isRequired,
    updateMandateCompany: PropTypes.func.isRequired,
  };

  onSubmit = async (values) => {
    const result = values[formRegisterRepresentativeCompanyFields.MANDATE_ID]
      ? await this.props.updateMandateCompany(values)
      : await this.props.addMandateCompany(values);
    if (!result?.error) {
      this.props.closeModal();
    }
  };

  render() {
    const { t, isLoading, closeModal, initialValues } = this.props;

    const validate = makeRffValidateFromLegacy(
      validateSchema,
      this.props,
      initialValues
    );

    return (
      <Form
        onSubmit={this.onSubmit}
        validate={validate}
        initialValues={initialValues}
        initialValuesEqual={isEqual}
        render={({ handleSubmit }) => (
          <Spin spinning={isLoading}>
            <form
              className="form-register-representation-company"
              onSubmit={handleSubmit}
            >
              <FormStateToRedux form={FORM_REGISTER_REPRESENTATIVE_COMPANY} />
              <RegisterRepresentCompanyFields t={t} closeModal={closeModal} />
            </form>
          </Spin>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const isLoading = getLoadingSelector(
    getAddMandateCompany,
    getUpdateMandateCompany
  )(state);

  return {
    isLoading,
  };
};

const mapDispatchToProps = {
  addMandateCompany,
  updateMandateCompany,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterRepresentCompany);
